import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { ContactDto } from "../model/contact.model"
import { Observable } from "rxjs"

@Injectable({ providedIn: 'root' })
export class ContactApi {

    constructor(
        private _httpClient: HttpClient
    ) {
        
    }

    // getById(idContact: number): Observable<ContactDto> {
    //     return this._httpClient
    //         .get<ContactDto>(`api/contact/${idContact}/detail`, { withCredentials: true })
    // }

    save(contactDto: ContactDto): Observable<ContactDto> {
        return this._httpClient
            .post<ContactDto>(`api/contact/create`, contactDto, { withCredentials: true })
    }
}